"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
const labels = exports.labels = {
  he: {
    newItemLabel: 'חדש',
    more: 'עוד',
    sidebarAriaLabel: 'תפריט צד'
  },
  ar: {
    newItemLabel: 'جديد',
    more: 'اخرى',
    sidebarAriaLabel: 'قائمة جانبية'
  },
  en: {
    newItemLabel: 'New',
    more: 'more',
    sidebarAriaLabel: 'Side Menu'
  }
};